export type ZoneIconName = "deck" | "discard" | "hand";

export function ZoneIcon({ name }: { name: ZoneIconName }) {
  if (name === "deck") {
    // 斜め上から見たカードの山。上面は最上のカードだけ、
    // 下のカードは手前側の側面に重なって見える
    return (
      <svg className="zone-icon" viewBox="0 0 24 24" aria-hidden="true">
        <path d="M4.5 8.5h12l3.5-4h-12z" />
        <path d="M4.5 8.5V19h12V8.5" />
        <path d="M16.5 8.5l3.5-4V15l-3.5 4z" />
        <path d="M4.5 12h12M4.5 15.5h12" />
        <path d="M16.5 12l3.5-4M16.5 15.5l3.5-4" />
      </svg>
    );
  }
  if (name === "discard") {
    // 欠けのない、連続した弧と矢印のサイクル
    return (
      <svg className="zone-icon" viewBox="0 0 24 24" aria-hidden="true">
        <path d="M3.5 12a8.5 8.5 0 0 1 14.5-6l2.5 2.5" />
        <path d="M20.5 3.5v5h-5" />
        <path d="M20.5 12a8.5 8.5 0 0 1-14.5 6l-2.5-2.5" />
        <path d="M3.5 20.5v-5h5" />
      </svg>
    );
  }
  // 扇状に広げた手札。右のカードが一番手前。塗りつぶしで手前が奥を隠す
  return (
    <svg className="zone-icon" viewBox="0 0 24 24" aria-hidden="true">
      <g transform="rotate(-18 12 19.5)">
        <rect className="zone-icon-card" x="7.5" y="4.5" width="9" height="15" rx="1.5" />
      </g>
      <rect className="zone-icon-card" x="7.5" y="4.5" width="9" height="15" rx="1.5" />
      <g transform="rotate(18 12 19.5)">
        <rect className="zone-icon-card" x="7.5" y="4.5" width="9" height="15" rx="1.5" />
      </g>
    </svg>
  );
}
